import { createActions } from 'redux-arc'

export const { types, creators } = createActions('notifications', {
  addNotification: null,
  removeNotification: null
})
